import { ArrowUpward } from "@mui/icons-material";
import { Box } from "@mui/material";
import React, { useEffect } from "react";

export const StockProductsScrollButton = ({ containerId }) => {
  const [showScrollTop, setShowScrollTop] = React.useState(false);

  useEffect(() => {
    const container = document.getElementById(containerId);

    if (!container) return;

    const onScroll = () => setShowScrollTop(container.scrollTop > 0);

    // initialize
    onScroll();
    container.addEventListener("scroll", onScroll, { passive: true });

    return () => container.removeEventListener("scroll", onScroll);
  }, [containerId]);

  const scrollToTop = () => {
    const container = document.getElementById(containerId);
    if (container) {
      container.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  return (
    <Box
      onClick={scrollToTop}
      role="button"
      aria-label="scroll to top"
      sx={{
        position: "fixed",
        right: 24,
        bottom: 24,
        width: 44,
        height: 44,
        bgcolor: "primary.main",
        color: "#fff",
        borderRadius: "50%",
        display: showScrollTop ? "flex" : "none",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: 3,
        cursor: "pointer",
        zIndex: 1300,
      }}
    >
      <ArrowUpward />
    </Box>
  );
};
